<template>
  <header class="header-title">
    <el-button
      v-if="previousAction"
      icon="el-icon-arrow-left"
      class="header-title-button"
      @click="goTo(previousAction)" />

    <div class="representative-user">
      <img
        alt="Votre interlocuteur"
        class="representative-user-picture"
        :src="userImage || 'https://maprochaineauto-public-s3.s3.eu-west-3.amazonaws.com/profile-pictures/default_thumbnail.jpg'">
      <div class="representative-user-info">
        <span>{{ userFullname }}</span>
        <span v-if="workspaceName"><span>pour</span> {{ workspaceName }}</span>
      </div>
    </div>

    <el-button
      icon="el-icon-close"
      class="header-title-button close-button"
      @click="closeBmFrame" />
  </header>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "HeaderTitle",
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    previousAction: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({ workspaceName: state => state.workspace ? state.workspace.name : null }),
    userImage() {
      return this.user
        ? this.user.picture_thumbnail_url
        : "https://maprochaineauto-public-s3.s3.eu-west-3.amazonaws.com/profile-pictures/nathalie_thumbnail.png"
    },
    userFullname() {
      return this.user
        ? `${this.user.firstname} ${this.user.lastname}`
        : "Assistant virtuel de Nathalie"
    }
  },
  methods: {
    goTo(name) {
      if (name) {
        this.$router.push({ name })
      }
    },
    closeBmFrame() {
      window.parent.postMessage({ instructionCode: "close" }, "*")
    }
  }
}
</script>

<style lang="scss">
.header-title-button i {
  font-weight: bold;
  color: color(gray02);
}
</style>

<style lang="scss" scoped>
.header-title {
  display: flex;
  align-items: center;
  padding: 12px 48px 12px 16px;
  border-bottom: 1px solid color(gray05);
  z-index: 1;
  flex-shrink: 0;

  .representative-user {
    display: flex;
    flex-direction: row;
    align-items: center;

    &-picture {
      height: 48px;
      width: 48px;
      border-radius: 50%;
      margin-right: 12px;
    }

    &-info {
      color: color(gray01);

      > span {
        display: block;

        span {
          color: color(gray03);
        }
      }
    }
  }

  .header-title-button {
    z-index: 2;
    margin-right: 16px;
    font-size: 18px;
    padding: 10px 12px;
    border-color: transparent;
  }

  .close-button {
    position: absolute;
    top: 15px;
    right: 0px;
  }
}
</style>
